/**
 * Definition for result status returned from a function call
 */
export var FUNCTION_RESULT_STATUS;
(function (FUNCTION_RESULT_STATUS) {
  FUNCTION_RESULT_STATUS["ERROR"] = "ERROR";
  FUNCTION_RESULT_STATUS["SUCCESS"] = "SUCCESS";
  FUNCTION_RESULT_STATUS["UNKNOWN"] = "UNKNOWN";
  FUNCTION_RESULT_STATUS["NOT_FOUND"] = "NOT_FOUND";
})(FUNCTION_RESULT_STATUS || (FUNCTION_RESULT_STATUS = {}));